<text-typography customCssClass="me-1">{{ text }}</text-typography
><legend-typography customCssClass="me-1">{{ legend }}</legend-typography>
